/**
 * Mobile tracking page names
 * Centralized constants for page tracking across microfrontends
 */

export enum FactoryGptPage {
  HOME = 'Home factorygpt',
  ALERTAS = 'Alertas',
  INFORMES = 'Informes',
}

export enum NotificationPage {
  CONFIGURACION = 'Configuración alertas',
}

export enum EfficiencyPage {
  STATIONS = 'Monitoreo de lineas',
}
